import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses } from '../shared/js';
import { Container, Icons } from '..';

import styles from './quote-progress.module.scss';

const QuoteProgress = ({ id, title, stepTitle, progress, ...props }) => {
  const width = `${progress}%`;
  const complete = progress >= 100;
  return (
    <div
      id={id}
      className={cn(
        styles.progressBar,
        applyClasses(props, styles),
        // eslint-disable-next-line react/prop-types
        props.className
      )}
    >
      <Container>
        <div className={styles.titles}>
          <span className={styles.title}>{title}</span>
          <Icons.ChevronThick className={styles.chevron} />
          <span className={styles.stepTitle}>{stepTitle}</span>
        </div>
        <div className={styles.fillContainer}>
          <div className={styles.emptyLine} />
          <div
            className={cn(styles.fill, { [styles.complete]: complete })}
            style={{ width }}
          >
            <div className={styles.fillLine} />
          </div>
        </div>
      </Container>
    </div>
  );
};

QuoteProgress.propTypes = {
  /** The ID of the element. Useful to select the element during testing. */
  id: PropTypes.string,
  /** The title of the progress bar */
  title: PropTypes.string,
  /** The title of the current step */
  stepTitle: PropTypes.string,
  /** The completion percentage */
  progress: PropTypes.number,
};

QuoteProgress.defaultProps = {
  title: undefined,
  stepTitle: undefined,
  currentStep: undefined,
  totalSteps: undefined,
  progress: 0,
};

export default QuoteProgress;
